export enum DocHeaderFilterStatus {
    New,
    SentToErp,
    ReadyToQuote,
    Quoted,
    Duplicate
}

